import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-trocar-perfil',
  templateUrl: './trocar-perfil.component.html',
  styleUrls: ['./trocar-perfil.component.scss'],
})
export class TrocarPerfilComponent {

  @Input() perfis: any = [];
  @Input() perfilSelecionado: any;

  constructor(
    private popoverController: PopoverController
  ) { }

  ionViewDidEnter() {
    this.perfis.sort(this.orderByDescricao);
  }

  orderByDescricao(a, b) {
    if (a.descricao.toLowerCase() > b.descricao.toLowerCase()) {
      return 1;
    }
    if (a.descricao.toLowerCase() < b.descricao.toLowerCase()) {
      return -1;
    }
    return 0;
  }

  close(perfil: any) {
    this.popoverController.dismiss(perfil);
  }

}
